export type SentryEnvironmentConfig = {
  environment: string;
  enabled: boolean;
  release: string;
  sampleRate: number;
  tracesSampleRate: number;
  replaysSessionSampleRate: number;
  replaysOnErrorSampleRate: number;
};

export const getSentryConfig = ({
  hostname = '',
}: Location): SentryEnvironmentConfig => {
  const release = import.meta.env.VITE_SENTRY_VERSION || '';
  switch (hostname) {
    case 'secure2.convio.net':
      return {
        environment: 'dev',
        enabled: false,
        release,
        sampleRate: 0,
        tracesSampleRate: 0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
      };
    case 'fundraising.qa.stjude.org':
      return {
        environment: 'qa',
        enabled: true,
        release,
        sampleRate: 1.0,
        tracesSampleRate: 0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
      };
    case 'fundraising.stjude.org':
      return {
        environment: 'prod',
        enabled: true,
        release,
        sampleRate: 1.0,
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
      };
    default:
      return {
        environment: 'local',
        enabled: false,
        release,
        sampleRate: 0,
        tracesSampleRate: 0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
      };
  }
};
